export const STORE_SLIDERS = 'STORE_SLIDERS'

export const STORE_ABOUT = 'STORE_ABOUT'

export const STORE_CATEGORIES = 'STORE_CATEGORIES'

export const STORE_PRODUCTS = 'STORE_PRODUCTS'

export const STORE_COMPANY_VALUES = 'STORE_COMPANY_VALUES'

export const STORE_CONTACTS = 'STORE_CONTACTS'

export const STORE_ALBUMS = 'STORE_ALBUMS'